export default __webpack_public_path__ + "bb1c24e971abe2e2ac4e33705aeb08cf.png";